import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { FileViewModel } from '@smarttask-common/src/lib/models/File/FileViewModel';

export enum FileViewActionTypes {
    ADD_FILEVIEW = '[FileView] Create FileView',
    ADD_FILEVIEWS = '[FileView] Add FileViews',
    UPSERT_FILEVIEW = '[FileView] Upsert FileView',
    UPSERT_FILEVIEWS = '[FileView] Upsert FileViews',
    UPDATE_FILEVIEW = '[FileView] Update FileView',
    UPDATE_FILEVIEWS = '[FileView] Update FileViews',
    DELETE_FILEVIEW = '[FileView] Delete FileView',
    DELETE_FILEVIEWS = '[FileView] Delete FileViews',
    DELETE_ALL_FILEVIEWS = '[FileView] Delete All FileViews',
    DELETE_ALL = '[FileView] Delete All',

    UPDATE_SELECTED_ID = '[FileView] Update SelectedId',
}

export class UpdateSelectedFileViewId implements Action {
    readonly type = FileViewActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_file_id: number) {}
}

export class AddOne implements Action {
    readonly type = FileViewActionTypes.ADD_FILEVIEW;
    constructor(public file_view: FileViewModel) {}
}

export class AddMany implements Action {
    readonly type = FileViewActionTypes.ADD_FILEVIEWS;
    constructor(public file_views: Array<FileViewModel>) {}
}

export class UpsertOne implements Action {
    readonly type = FileViewActionTypes.UPSERT_FILEVIEW;

    constructor(public file_view: FileViewModel) {}
}

export class UpsertMany implements Action {
    readonly type = FileViewActionTypes.UPSERT_FILEVIEWS;
    constructor(public file_views: Array<FileViewModel>) {}
}

export class UpdateOne implements Action {
    readonly type = FileViewActionTypes.UPDATE_FILEVIEW;
    constructor(public file_view: Update<FileViewModel>) {}
}

export class UpdateMany implements Action {
    readonly type = FileViewActionTypes.UPDATE_FILEVIEWS;
    constructor(public file_views: Array<Update<FileViewModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = FileViewActionTypes.DELETE_FILEVIEW;
    constructor(public id: number) {}
}

export class DeleteMany implements Action {
    readonly type = FileViewActionTypes.DELETE_FILEVIEWS;
    constructor(public ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = FileViewActionTypes.DELETE_ALL_FILEVIEWS;
    constructor(public ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = FileViewActionTypes.DELETE_ALL;
    constructor() {}
}

export type FileViewActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedFileViewId;
